import { Button, ButtonGroup } from 'reactstrap';

import { FontAwesomeIcon } from '@hsp/react-component-library';

import './top-support-button.scss';

const Scroll = () => {
  return (
    <ButtonGroup vertical>
      <Button
        color="white"
        size="sm"
        type="button">
        <FontAwesomeIcon icon={['fas', 'chevron-up']} />
        Top
      </Button>
      <Button
        color="white"
        onClick={(e) => e.stopPropagation()}
        size="sm"
        type="button">
        <FontAwesomeIcon icon={['fas', 'headset']} />
        Support
      </Button>
    </ButtonGroup>
  );
};

export default Scroll;
